
define('text!editor/edit/contexts/settings.html',[],function () { return '<div class="context-content">\r\n    <h4>Settings</h4>\r\n    \r\n    <!-- ko compose: settingsForm--><!--/ko-->\r\n    \r\n    <button class="btn btn-primary" data-bind="click: save">update</button>\r\n</div>\r\n';});

